export default "__VITE_ASSET__CBrrSBDj__"